// extracted by mini-css-extract-plugin
module.exports = {"infoBoxJtails":"SectionInfoBox-Jtails_infoBoxJtails_1B-sk","isStyleDingBeauty":"SectionInfoBox-Jtails_isStyleDingBeauty_3QK9-"};